<div class="form-control border-0 pl-0">
  <strong><ng-content></ng-content></strong>
</div>
